import { OperationType } from "interfaces";
import { api } from "./api";
import { ENDPOINTS } from "./endpoints";

export const generateOperation = (type: OperationType, formData?: string): Promise<any> => {
  return api.post(ENDPOINTS.generateOperation(type), formData, {
    contentType: "multipart/form-data",
  });
};
